export enum DocumentSourceType {
    CUSTOMER = '1',
    CARD = '2',
    OPPORTUNITY = '3',
    ACTIVITY = '4',
    ASSIGNMENT = '5'
}
